import axiosInstance from "../config/axiosInstance"


export const deleteUser = async (id) => {

    const response = await axiosInstance.delete(`/api/admin/delete/user/${id}`);
    return response;
}